import React, { useEffect, useState } from "react";
import { Modal, ModalDialog, Button, Input } from "@mui/joy";
import { postFetch } from "../../../../../../fetch/fetch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styles from "./phoneinbound.module.css";

const toastOptions : any = {
    position: "bottom-right",
    autoClose: 3000,
    hideProgressBar: true,
    theme: "colored"
};

//큐 제거 비밀번호 모달 (비밀번호는 서버 .env에서만 비교, 프론트에는 없음)
const QueuePasswordModal : React.FC<any> = (props) => {

    const [password, setPassword] = useState<string>("");
    const [error, setError] = useState<string>("");
    const [submitting, setSubmitting] = useState<boolean>(false);

    useEffect(() => {
        if (props.open) {
            setPassword("");
            setError("");
            setSubmitting(false);
        }
    }, [props.open]);

    const q = props.queue;
    if (!q) {
        return null;
    }

    const submit = async () => {
        if (password.length !== 4) {
            setError("비밀번호 4자리를 입력해주세요");
            return;
        }
        setSubmitting(true);
        setError("");
        try {
            const result : any = await postFetch("/dashboard/callcenter/queues/remove", {
                groupId: props.groupId,
                queue: q.queue,
                password
            });
            if (result.message === "success") {
                toast.success(`'${q.name}' 큐를 그룹에서 제거했습니다`, toastOptions);
                props.onRemoved(q.queue);
                props.onClose();
            } else if (result.message === "wrongPassword") {
                setError("비밀번호가 맞지 않습니다");
            } else if (result.message === "NOT_AUTHORIZED") {
                setError("큐 편집 권한이 없습니다");
            } else {
                setError("교환기 반영 실패");
            }
        } catch (e) {
            console.log(e);
            setError("교환기 반영 실패");
        }
        setSubmitting(false);
    };

    return (
        <Modal open={props.open} onClose={props.onClose}>
            <ModalDialog>
                <div style={{ width: "340px" }}>
                    <div className={styles.modalTitle}>큐 제거</div>
                    <div style={{ fontSize: "14px", lineHeight: 1.5 }}>
                        '{q.name}'{q.name !== q.queue ? ` (${q.queue})` : ""} 큐를 이 그룹에서 제거합니다.<br />
                        <b>이 큐로 오는 전화를 받을 사람이 없어집니다.</b>
                    </div>

                    <div className={styles.modalLabel}>비밀번호 (4자리)</div>
                    <Input
                        type="password"
                        value={password}
                        placeholder="••••"
                        onChange={(e) => setPassword(e.target.value.replace(/[^0-9]/g, "").slice(0, 4))}
                        onKeyDown={(e) => { if (e.key === "Enter") submit(); }}
                        slotProps={{ input: { maxLength: 4, inputMode: "numeric", autoFocus: true } }}
                    />
                    {
                        error ?
                            <div className={styles.modalError}>{error}</div>
                            :
                            ""
                    }

                    <div className={styles.modalButtons}>
                        <Button variant="plain" color="neutral" onClick={props.onClose} disabled={submitting}>취소</Button>
                        <Button variant="solid" color="danger" onClick={submit} loading={submitting}>큐 제거</Button>
                    </div>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default QueuePasswordModal;
